import * as React from 'react'
import { BPMChart } from '../../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../../api'
import { GroupByType } from '../../../../components/GroupByType'

export const LocationChart: React.FunctionComponent = (props) => {

    const [groupBy, setGroupBy] = React.useState<string>('country')
    const toolbarItems = GroupByType([{ val: 'country', display: 'Country' }, { val: 'city', display: 'City' }, { val: 'region', display: 'Region' }], groupBy, (selected) => {
        setGroupBy(selected!)
    }, false)

    return (
        <BPMChart {...props} title='Locations' type='tree' subTitle={`By Downloads`}
            onRequestLoad={(options, signal) => {
                return BPMAnalyticsAPI.get<any>('downloads/byGroup', options, signal).then((data) => {
                    return data.sort((item1, item2) => {
                        return item1.count - item2.count
                    }).reverse().slice(0, 100)
                })
            }} additionalParams={{ groupBy: groupBy }} toolBarItems={() => toolbarItems}
            allowedTypes={['spline', 'bar', 'doughnut', 'pie', 'tree']}
            series={{
                name: 'Downloads', valueField: 'count', argumentField: groupBy,
                smallValuesGrouping: { topCount: 10, mode: 'topN' }
            }}>
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Downloads/charts/LocationChart.tsx